/**
 * Auto-Provisioning Types
 * Based on the Python agent.py dataclasses
 */
/**
 * Column mapping variations for flexible matching
 */
export const COLUMN_MAPPINGS = {
    lastName: ["Last Name", "LastName", "Surname", "Last"],
    firstName: ["First Name", "FirstName", "First", "Given Name"],
    middleName: ["Middle Name/Initial", "MiddleName", "Middle", "MI"],
    suffix: ["Suffix"],
    npi: ["NPI", "NPI Number", "National Provider Identifier"],
    username: ["Username (UPN)", "Username", "UPN", "Active Directory", "Active Directory (AD) / (UPN), if applicable"],
    clinicalSystemId: ["Clinical System ID Number", "Integration Key", "Clinical System ID", "System ID"],
    gender: ["Gender"],
    credentials: ["Credentials"],
    specialty: ["Specialty", "Speciality", "Medical Specialty"],
    practiceName: ["Practice Name", "Practice", "Organization"],
    officeNumber: ["Office Mainline Number", "Office Number", "Main Number", "Phone"],
    siteNames: ["Site Name(s)", "Site", "Sites", "Location"],
    email: ["Email", "Email Address", "Recovery Email"],
    mobileNumber: ["Mobile Number", "Mobile", "Cell Phone", "Cell", "Mobile Number (Please enter with no hyphens)"],
    mobileCarrier: ["Mobile Carrier", "Carrier"],
    pagerNumber: ["Pager Number", "Pager", "Pager Number, if applicable", "Pager Number, if applicable (Please enter with no hyphens)"],
    pagerCarrier: ["Pager Carrier"],
    copyUserId: [
        "Reference V5UserId",
        "Reference V5 UserId",
        "Reference Identity Id",
        "Reference IdentityId",
        "Copy User V5UserId",
        "Copy User ID",
        "CopyUserID",
        "Reference User ID",
        "Copy From",
        "Copy User - (For PS Internal Use Only)",
    ],
    action: ["Action", "Action Type"],
    integrationMappings: ["Integration Mappings", "Mappings", "Integration Data", "Qgenda/AMiOn ID, if applicable"],
    createdOn: ["Created On", "CreatedOn", "Creation Date"],
    v5UserId: ["V5UserId", "V5 UserId", "V5 User ID", "User ID"],
    identityId: ["IdentityId", "Identity Id", "Identity ID"],
    errors: ["Errors", "Error Messages", "Error"],
};
/**
 * CSV column headers in the correct order
 */
export const CSV_HEADERS = [
    "Last Name",
    "First Name",
    "Middle Name/Initial",
    "Suffix",
    "NPI",
    "Username (UPN)",
    "Clinical System ID Number",
    "Gender",
    "Credentials",
    "Specialty",
    "Practice Name",
    "Office Mainline Number",
    "Site Name(s)",
    "Email",
    "Mobile Number",
    "Mobile Carrier",
    "Pager Number",
    "Pager Carrier",
    "Action",
    "Integration Mappings",
];
// Note: JOB_STATUS, SOURCE_IDS, and PROVISIONING_URLS have been moved to:
// - JOB_STATUS: provisioningService.ts (local constant)
// - SOURCE_IDS/PROVISIONING_URLS: @perfectserve/env-ps (provisioningSourceId, provisioningApi)
